import { useRef, useState } from "react";
import { Navbar } from "@/components/Navbar";
import { RevelleAvatarPanel } from "@/components/RevelleAvatarPanel";
import { ChatInterface } from "@/components/ChatInterface";
import { LeadCaptureModal } from "@/components/LeadCaptureModal";
import { EditorialMarquee } from "@/components/EditorialMarquee";


export default function ChatPage() {
  const [leadOpen, setLeadOpen] = useState(false);
  const [agentStatus, setAgentStatus] = useState("ready");
  const userCountRef = useRef(0);
  const leadShownRef = useRef(false);

  const handleUserMessage = (text) => {
    userCountRef.current += 1;
    if (leadShownRef.current) return;
    if (userCountRef.current >= 3) {
      leadShownRef.current = true;
      setTimeout(() => setLeadOpen(true), 1800);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white" data-testid="chat-page">
      <Navbar onBookCall={() => setLeadOpen(true)} />
      <main className="mx-auto grid max-w-7xl grid-cols-1 items-stretch gap-6 px-4 pb-4 pt-24 sm:px-6 lg:grid-cols-12 lg:gap-8 lg:px-8">
        <div className="lg:col-span-5">
          <RevelleAvatarPanel status={agentStatus} />
        </div>
        <div className="lg:col-span-7">
          <ChatInterface onUserMessage={handleUserMessage} onStatusChange={setAgentStatus} />
        </div>
      </main>
      <EditorialMarquee />
      <LeadCaptureModal open={leadOpen} onClose={() => setLeadOpen(false)} />
    </div>
  );
}
